<template>
  <td class="pr-4">
    <h6 class="custom-margin-h6-table">
      <strong>{{ $t('common_words.color_range_details') }}:</strong>
    </h6>
    <span v-for="(detail, index) in range_details" :key="index" class="mb-2">
      <el-tag style="height: auto; color: black; width: 100%" type="info">
        <div class="row pt-2">
          <div class="col-2 col-sm-2 col-md-6 col-lg-3 col-xl-3">
            <h6 class="mb-2">
              <strong>{{ $t('common_words.range') }}</strong>
            </h6>
            <p>
              {{ model.range[index] }}
            </p>
          </div>
          <div class="col-10 col-sm-10 col-md-6 col-lg-3 col-xl-3">
            <h6 class="mb-2">
              <strong>{{ $t('common_words.name') }}</strong>
            </h6>
            <p>
              {{ model.name_range[index] }}
            </p>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <h6 class="mb-2">
              <strong>{{ $t('common_words.color') }}</strong>
            </h6>
            <div
              :style="`background-color: ${model.background_color[index]};
            border:solid`"
            >
              <p>{{ model.background_color[index] }}</p>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <h6 class="mb-2">
              <strong>{{ $t('common_words.text_color') }}</strong>
            </h6>
            <div
              :style="`background-color: ${model.text_color[index]}; border:solid;`"
            >
              <p>{{ model.background_color[index] }}</p>
            </div>
          </div>
        </div>
        <div class="row pt-2">
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <h6 class="mb-2">
              <strong>{{ $t('common_words.from2') }}</strong>
            </h6>
            <p>{{ model.from[index] }}</p>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <h6 class="mb-2">
              <strong>{{ $t('common_words.operator_from') }}</strong>
            </h6>
            <p>{{ model.from_operator[index] }}</p>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <h6 class="mb-2">
              <strong>{{ $t('common_words.to') }}</strong>
            </h6>
            <p>{{ model.to[index] }}</p>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <h6 class="mb-2">
              <strong>{{ $t('common_words.operator_to') }}</strong>
            </h6>
            <p>{{ model.to_operator[index] }}</p>
          </div>
        </div>
      </el-tag>
    </span>
  </td>
</template>
<script>
export default {
  name: 'info-range-details',
  props: {
    range_details: {
      type: Array,
      default: () => [],
    },
    model: {
      type: Object,
      required: true,
    },
  },
};
</script>
